import React from 'react'

import * as c from '../../../common'
import { roofClaimAutofillValues } from '../../../common/helpers/roofClaimAutofill'
import {
  ROOF_SECTION_SHOWN,
  RoofSectionDisplay,
  roofClaimLocked,
} from '../../routes/customer-report/roofClaimFlow'
import { RoofClaimContext } from './RoofClaimContext'

import RoofClaimingContractMainPage from './RoofClaimingContractMainPage'
import RoofThirdPartyAuthorization from './RoofThirdPartyAuthorization'

import RoofClaimingContractWarranty from './RoofClaimingContractWarranty'

export interface RoofClaimingContractPagesProps {
  readOnly?: boolean
  isPDF?: boolean
  company: string
  customer: c.Customer
  customerID: string
  autofillCleared: ReadonlySet<string>
  onAutofillClearedChange: (field: string, cleared: boolean) => void
  onOpenSignatureRoofClaimClient: c.VoidFn
  onOpenSignatureRoofClaimRep: c.VoidFn
  /** Agreement + warranty, per the report menu's Roof Claim option. */
  claimDisplay?: RoofSectionDisplay
  /** The report menu's Authorization Form option. */
  authorizationDisplay?: RoofSectionDisplay
  /** Remote link (13411491362): a section not sent is not rendered at all. */
  renderClaim?: boolean
  renderAuthorization?: boolean
}

export default React.memo<RoofClaimingContractPagesProps>(function ({
  company,
  readOnly = false,
  isPDF = false,
  customer,
  customerID,
  autofillCleared,
  onAutofillClearedChange,
  onOpenSignatureRoofClaimClient,
  onOpenSignatureRoofClaimRep,
  claimDisplay = ROOF_SECTION_SHOWN,
  authorizationDisplay = ROOF_SECTION_SHOWN,
  renderClaim = true,
  renderAuthorization = true,
}) {
  return (
    <RoofClaimContext.Provider
      value={{
        locked: roofClaimLocked(customer),
        readOnly,
        isPDF,
        autofill: roofClaimAutofillValues(customer),
        cleared: autofillCleared,
        onClearedChange: onAutofillClearedChange,
      }}
    >
      {/* Stay mounted while hidden: guided signing reads pending signatures
          from the DOM. display: contents keeps the report's page gap. */}
      {renderClaim && (
        <div style={sectionStyle(claimDisplay)}>
          <RoofClaimingContractMainPage
            company={company}
            customer={customer}
            customerID={customerID}
            noPDF={claimDisplay.noPDF}
            onOpenRoofClaimClientSigning={onOpenSignatureRoofClaimClient}
            onOpenRoofClaimRepSigning={onOpenSignatureRoofClaimRep}
          />
          <RoofClaimingContractWarranty
            company={company}
            customerID={customerID}
            companyContractor={CONTRACTOR_COMPANY}
            noPDF={claimDisplay.noPDF}
          />
        </div>
      )}
      {renderAuthorization && (
        <div style={sectionStyle(authorizationDisplay)}>
          <RoofThirdPartyAuthorization
            company={company}
            customerID={customerID}
            customer={customer}
            noPDF={authorizationDisplay.noPDF}
            readOnly={readOnly}
            isPDF={isPDF}
          />
        </div>
      )}
    </RoofClaimContext.Provider>
  )
})

const CONTRACTOR_COMPANY: c.RoofClaimingContractorCompany = 'ecohome'

const sectionStyle = ({ hidden }: RoofSectionDisplay): React.CSSProperties => ({
  display: hidden ? 'none' : 'contents',
})
